import { render, staticRenderFns } from "./marcas.vue?vue&type=template&id=82102180"
import script from "./marcas.vue?vue&type=script&lang=js"
export * from "./marcas.vue?vue&type=script&lang=js"
import style0 from "./marcas.vue?vue&type=style&index=0&id=82102180&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports